<template>
    <div>
        <!-- Read-only: static badge, no dropdown (used for subject/source rows). -->
        <span
            v-if="readonly"
            class="label label-rouded"
            :class="value == true ? 'label-success' : 'label-danger'"
        >
            <span v-if="value == true">{{ $t("general:yes") }}</span>
            <span v-else>{{ $t("general:no") }}</span>
            <i class="m-l-5 fa"
                :class="value == true ? 'fa-check' : 'fa-close'"
            />
        </span>
        <b-dropdown v-else size="md" variant="link" class="arvio-pra-true-false-selector">

            <template #button-content>
                <span
                    class="label label-rouded"
                    :class="value == true ? 'label-success' : 'label-danger'"
                >
                    <span v-if="value == true">{{ $t("general:yes") }}</span>
                    <span v-else>{{ $t("general:no") }}</span>
                    <i class="m-l-5 fa"
                        :class="value == true ? 'fa-check' : 'fa-close'"
                    />
                </span>
            </template>

            <b-dropdown-item @click="$emit('select', true)">
                <span class="label label-rouded label-success">
                    Da <i class="fa fa-check" />
                </span>
            </b-dropdown-item>

            <b-dropdown-item @click="$emit('select', false)">
                <span class="label label-rouded label-danger">
                    Ne <i class="fa fa-close" />
                </span>
            </b-dropdown-item>

        </b-dropdown>
    </div>
</template>

<script>

export default {
    model: {
        prop: 'value',
        event: 'select'
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style>
.arvio-pra-true-false-selector .dropdown-menu {
    min-width: 10px;
    padding: 0px;
}
.arvio-pra-true-false-selector .btn-link:hover {
    text-decoration: none;
}
.arvio-pra-true-false-selector .dropdown-toggle {
    padding: 0;
}
</style>